import FlexColumn from "@/components/FlexColumn.vue";
import ActionsSection from "./sections/ActionsSection.vue";
import SearchElement from "./SearchElement.vue";
export default {
  name: "WrapWithDropdownBody",
  components: {
    FlexColumn,
    ActionsSection,
    SearchElement
  },
  props: {
    showSearcher: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    debounce: {
      type: Boolean,
      default: true
    },
    // The filter's current search term. Watched so the input clears whenever the
    // term is reset to empty (dropdown closed → draft discarded, or clear pressed).
    keyword: {
      type: [String, Array],
      default: ""
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    actionsText: {
      type: [Object, String],
      default: null
    },
    // Filter-type label used to fill the {name} template in actionsText.
    name: {
      type: String,
      default: ""
    }
  },
  emits: ["hidden", "discard", "apply", "closeDropdown", "search", "restoreSearch"],
  watch: {
    keyword(newVal) {
      const isEmpty = newVal == null || newVal === "" || Array.isArray(newVal) && newVal.length === 0;
      if (isEmpty) {
        this.$refs.searcher?.clearSearch();
      }
    }
  },
  mounted() {
    window.$bus.on("DROPDOWN_HIDDEN", () => this.$emit("hidden"));
  },
  beforeUnmount() {
    window.$bus.off("DROPDOWN_HIDDEN", () => this.$emit("hidden"));
  }
};